import { useShallow } from 'zustand/shallow'
import type { TComplianceVersion } from 'helpers/getComplianceVersion'
import { resolveComplianceVersion } from 'helpers/getComplianceVersion'
import { useFunnelsConfig } from 'hooks/useFunnelsConfig'
import { useZustandStore } from 'zustandGlobalStore'

export const useComplianceVersion = (): TComplianceVersion => {
  const { config } = useFunnelsConfig()
  const { geoData, leadCountry } = useZustandStore(
    useShallow((state) => ({
      geoData: state.geoData,
      leadCountry: state.lead?.country,
    })),
  )

  return resolveComplianceVersion({
    configFile: config,
    geoData,
    leadCountry,
  })
}
